export default __webpack_public_path__ + "static/media/schedule.a065406f.svg";